import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/outline';

const PropertyListingCTA: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      className="my-8 p-6 rounded-2xl bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-gray-800 dark:to-gray-900 border border-indigo-200 dark:border-indigo-700 shadow-lg flex flex-col sm:flex-row items-center justify-between gap-4 cursor-pointer hover:shadow-xl transition-all group"
      onClick={() => navigate('/list-your-property')}
      tabIndex={0}
      role="button"
      aria-label="List your property for free"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') navigate('/list-your-property');
      }}
    >
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0 bg-indigo-100 dark:bg-indigo-900 rounded-full p-3">
          <HomeIcon className="h-8 w-8 text-indigo-600 dark:text-indigo-300" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-indigo-800 dark:text-indigo-200 mb-1">
            List Your Property for Free Today!
          </h3>
          <p className="text-gray-700 dark:text-gray-300 text-sm max-w-xs">
            Reach thousands of interested tenants with RentSmart.ie – no fees to
            get started!
          </p>
        </div>
      </div>
      <button
        className="mt-4 sm:mt-0 px-6 py-2 rounded-full bg-indigo-600 text-white font-semibold shadow hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all"
        onClick={(e) => {
          e.stopPropagation();
          navigate('/list-your-property');
        }}
      >
        Get started
      </button>
    </div>
  );
};

export default PropertyListingCTA;
